const NF_SINAIS = [
  [/danfe/i, 4],
  [/nfs-?e/i, 4],
  [/nota fiscal/i, 4],
  [/infnfe/i, 5],
  [/chnfe/i, 4],
  [/\bnf-?e\b/i, 3],
]

const COBRANCA_SINAIS = [
  [/boleto/i, 4],
  [/linha digit[aá]vel/i, 5],
  [/documento de cobran[cç]a/i, 5],
  [/recibo do pagador/i, 4],
  [/febraban/i, 3],
  [/00020101/, 4],
]

const LINHA_DIGITAVEL = /\d{5}\.?\d{5}\s+\d{5}\.?\d{6}\s+\d{5}\.?\d{6}\s+\d\s+\d{14}/

export function classificarTexto(text = '', fileName = '') {
  const fonte = String(text || '').replace(/\u0000/g, '')
  let nf = 0
  let cobranca = 0
  NF_SINAIS.forEach(([re, peso]) => { if (re.test(fonte)) nf += peso })
  COBRANCA_SINAIS.forEach(([re, peso]) => { if (re.test(fonte)) cobranca += peso })
  const digits = fonte.replace(/\D/g, '')
  if (/\d{47}/.test(digits) || LINHA_DIGITAVEL.test(fonte)) cobranca += 5

  if (nf < 3 && cobranca < 3) {
    const nome = String(fileName || '').toLowerCase()
    if (/nota|danfe|nfs-?e|nf-?e/.test(nome) && !/boleto|cobran|pix/.test(nome)) nf += 3
    if (/boleto|cobran|pix/.test(nome) && !/nota|danfe|nfs-?e|nf-?e/.test(nome)) cobranca += 3
  }

  if (nf >= 3 && nf > cobranca) return 'nf'
  if (cobranca >= 3 && cobranca > nf) return 'cobranca'
  return null
}

async function inflatePdfStreams(raw) {
  if (typeof DecompressionStream === 'undefined') return ''
  const parts = []
  const re = /stream\r?\n([\s\S]*?)\r?\nendstream/g
  let match = re.exec(raw)
  let count = 0
  while (match && count < 6) {
    count += 1
    const bin = new Uint8Array(match[1].length)
    for (let i = 0; i < match[1].length; i += 1) bin[i] = match[1].charCodeAt(i) & 255
    const modes = ['deflate', 'deflate-raw']
    for (let i = 0; i < modes.length; i += 1) {
      try {
        const stream = new Blob([bin]).stream().pipeThrough(new DecompressionStream(modes[i]))
        const out = await new Response(stream).arrayBuffer()
        parts.push(new TextDecoder('latin1').decode(out))
        break
      } catch (error) {
        // tenta o outro formato de deflate
      }
    }
    match = re.exec(raw)
  }
  return parts.join('\n')
}

export async function classificarDocumentoCobrancaOuNf(file) {
  const blob = file?.data instanceof Blob ? file.data : file
  if (!blob || typeof blob.arrayBuffer !== 'function') return null
  const name = blob.name || blob.path || file?.data?.path || ''
  const bytes = new Uint8Array(await blob.arrayBuffer())
  const slice = bytes.length > 8000000 ? bytes.subarray(0, 8000000) : bytes
  const raw = new TextDecoder('latin1').decode(slice)
  const inflated = await inflatePdfStreams(raw)
  return classificarTexto(`${raw}\n${inflated}`, name)
}
